import { render, staticRenderFns } from "./MyPicture.vue?vue&type=template&id=5fa79195&scoped=true"
import script from "./MyPicture.vue?vue&type=script&lang=js"
export * from "./MyPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa79195",
  null
  
)

export default component.exports